<template>
  <div class="statistic-widget-top-selling-product">
    <div class="card-header-tab card-header">
      <div class="card-header-title">Top selling</div>
      <div class="btn-actions-pane-right scrollbar">
        <div role="group" class="btn-group-sm nav btn-group">
          <a v-for="currency in currencies" :key="currency.key" data-toggle="tab" href="#" :class="`btn-shadow btn btn-primary ${currency.key == selected ? 'active' : ''}`" @click.prevent="selected = currency.key">{{ currency.label }}</a>
        </div>
      </div>
    </div>
    <ul class="list scrollbar">
      <li v-for="(item, index) in Object.values(data?.[selected]?.items || [])" :key="index" class="d-flex mb-6">
        <div class="d-flex w-100 justify-content-between align-items-center">
          <div class="flex-1">
            <h6 class="mb-0 fw-normal d-flex align-items-center">
              <div class="widget-thumbnail">
                <Image :src="item.thumbnail" />
              </div>
              {{ item.title }}
            </h6>
          </div>
          <div class="number">
            <span>{{ item.number }}</span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: null
    }
  },
  computed: {
    data() {
      return this.config?.data || {}
    },
    currencies() {
      let currencies = []
      Object.entries(this.data).forEach(([key, item]) => {
        currencies.push({
          key: key,
          label: item.currency,
          priority: item?.items?.[0]?.number
        })
      })
      currencies.sort((a, b) => {
        if ((a.priority || 0) - (b.priority || 0) > 0) {
          return -1
        } else if ((a.priority || 0) - (b.priority || 0) < 0) {
          return 1
        }
        return 0
      })
      return currencies
    }
  },
  watch: {
    currencies: {
      handler(values) {
        this.selected = values?.[0]?.key
      },
      immediate: true
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.statistic-widget-top-selling-product {
  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: -45%;
    width: 100%;
    height: 100%;
    opacity: 0.3;
    z-index: 1;
    background: url(@/../assets/imgs/crown.png) bottom no-repeat;
    background-size: 75%;
    background-position: 0px -25px;
  }
  .card-header {
    position: relative;
    padding: 0 15px;
    margin: -15px -15px 0 -15px;
    z-index: 99;
    text-transform: none;
    .card-header-title {
      padding-right: 20px;
    }
    .btn-actions-pane-right {
      overflow-x: auto;
      overflow-y: hidden;
    }
    .nav {
      display: block;
    }
  }
  .widget-thumbnail {
    max-width: 48px;
    max-height: 48px;
    min-width: 48px;
    min-height: 48px;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 50%;
    border: 1px solid #ccc;
    margin-right: 10px;
    img {
      height: 48px;
      width: 48px;
      object-fit: contain;
    }
  }
  ul.list {
    position: relative;
    z-index: 9;
    max-height: 350px;
    overflow: auto;
    padding: 15px;
    margin: 0 -15px 0 -15px;
  }
  h6 {
    font-size: 1em;
    font-weight: 500;
    line-height: 1.4;
  }
}
</style>
